import baseRequest from "../_core/baseRequest";

export default {
    getTicketOptions: () => baseRequest.get("/tickets/options"),
    getTickets: params => baseRequest.post("/tickets/list", params),
    getTicketCounts: params => baseRequest.post("/tickets/counts", params),
    exportTickets: params => baseRequest.post("/tickets/export", params),
    getTicket: id => baseRequest.get(`/tickets/${id}`),
    uploadTicketPhoto: params => baseRequest.post("/tickets/photos", params),
    createTicket: params => baseRequest.post("/tickets/", params),
    getAssignableUsers: (role, ticketId, search) => {
        // URLSearchParams boşluğu '+' yapar; backend OpenAPI doğrulaması '+' içeren query'yi reddeder
        const query = Object.entries({role, ticketId, search})
            .filter(([, value]) => value)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
        return baseRequest.get(`/tickets/assignable-users?${query}`);
    },
    claimTicket: id => baseRequest.post(`/tickets/${id}/claim`),
    assignTicket: (id, params) => baseRequest.post(`/tickets/${id}/assign`, params),
    changeTicketPriority: (id, params) => baseRequest.patch(`/tickets/${id}/priority`, params),
    changeTicketVisibility: (id, params) => baseRequest.patch(`/tickets/${id}/visibility`, params),
    addTicketNote: (id, params) => baseRequest.post(`/tickets/${id}/notes`, params),
    closeTicket: (id, params) => baseRequest.post(`/tickets/${id}/close`, params),
    cancelTicket: (id, params) => baseRequest.post(`/tickets/${id}/cancel`, params),
    deleteTicket: id => baseRequest.patch(`/tickets/${id}/soft-delete`)
};
